export default __webpack_public_path__ + "static/media/herobg.6f69f406.jpg";